











































import { Component, Inject, Vue } from 'vue-property-decorator';
import { MetaInfo } from 'vue-meta/types/vue-meta';
import PaperCreateForm from '@/main-components/papers/PaperCreateForm.vue';
import PaperCreateInfo from '@/main-components/papers/PaperCreateInfo.vue';
import Icon from '@/main-components/common/Icon.vue';
import { getToken } from '@/utils/cookie';
import ModalVideo from '@/main-components/common/modal/ModalVideo.vue';
import { pageSEO } from '@/utils/seo';
import seoDefault from '@/utils/seo-default';

@Component({
  components: {
    PaperCreateForm,
    PaperCreateInfo,
    Icon,
    ModalVideo,
  },
  metaInfo(this: PaperCreate): MetaInfo {
    return {
      title: pageSEO.title.createBinaLatihan,
      link: [
        {
          vmid: 'canonical',
          rel: 'canonical',
          href: pageSEO.canonical.createBinaLatihan,
        },
      ],
      meta: [
        ...seoDefault({
          title: pageSEO.titleMeta.createBinaLatihan,
          description: pageSEO.description.createBinaLatihan,
        }),
      ],
    };
  },
})
export default class PaperCreate extends Vue {
  @Inject('colorBrandDarkPrimary')
  colorBrandDarkPrimary!: string;

  @Inject('colorBlackPrimary')
  colorBlackPrimary!: string;

  get closeButtonColor() {
    return this.colorBlackPrimary;
  }

  get closeButtonHoverColor() {
    return this.colorBrandDarkPrimary;
  }

  get isLoggedIn() {
    return getToken() ? true : false;
  }

  get isEmptyPapers() {
    return this.$route.query.isEmpty;
  }

  openVideoTutorialModal: any = null;

  onCloseClicked() {
    if (this.isLoggedIn) {
      if (this.isEmptyPapers) {
        this.$router.push(`/`);
      } else {
        this.$router.push(`/papers`);
      }
    } else {
      this.$router.push(`/`);
    }
  }

  openVideoTutorialModalAdd(openModal: any) {
    this.openVideoTutorialModal = openModal;
  }
}
